import application from 'application/application';

application.factory('httpInterceptor', [
	'$q',
	'$rootScope',
	'API',
	'notification',
	'authentication',
	'helper',
	($q, $rootScope, API, notification, authentication, helper) => {
		const responseHook = response => {
			if (response.data) {
				if (response.data.error) {
					response.data.status = {
						codigo: response.status,
						mensagem: response.data.error
					};
				}
				let { status, config, data } = response,
					shouldOverrideMessage = hasMessagesOverrides(response.config),
					hasMessage = data.status && data.status.mensagem,
					message = hasMessage ? data.status.mensagem : null;

				/** Verifica se a resposta é de erro. */
				if (/^2\d{2}$/.test(status)) {
					if (
						/^POST|PUT|DELETE/i.test(config.method) &&
						hasMessage &&
						config.data &&
						!config.data.silent
					) {
						if (shouldOverrideMessage.success) {
							response.config.messageOverride.success(response, notification);

							return response;
						} else notification.success(message);
					}
				} else if (hasMessage) {
					if (status === 401 && authentication.isLogged())
						$rootScope.callLoginModal();

					if (Array.isArray(data.status.erros))
						message +=
							'<hr />' +
							data.status.erros
								.map(
									e => `<div class="mt-2"><small>${e.mensagem}</small></div>`
								)
								.join('');

					if (shouldOverrideMessage.error)
						response.config.messageOverride.error(response, notification);
					else notification.danger(message);

					return $q.reject(response);
				}

				return response;
			}

			if (response.config.timeout.canceled) return $q.reject('Canceled');

			if (response.status !== -1 && response.status !== 200)
				notification.danger('Ocorreu um erro inesperado.');

			return $q.reject(response);
		};

		return {
			request(config) {
				if (config.url.indexOf('.html') != -1) return config;

				let currentAPIKey = Object.keys(API).find(
					key =>
						key !== 'default' &&
						helper.http(API[key], config.method, config.params).url ===
							config.url
				);

				if (API.hasOwnProperty(currentAPIKey)) {
					let currentAPI = API[currentAPIKey];

					if (
						typeof currentAPI === 'object' &&
						typeof currentAPI.hooks === 'object' &&
						typeof currentAPI.hooks.request === 'function'
					) {
						currentAPI.hooks.request(config);
					}
				}

				var re = new RegExp(
						Array.from(
							new Set(
								Object.keys(API)
									.filter(key => key !== 'login')
									.map(value => {
										let { protocol, hostname, port } = {
											...API.default,
											...API[value]
										};

										return (
											`^${protocol}\\/\\/${hostname.replace(/\./g, '\\.')}` +
											(port ? `:${port}` : '')
										);
									})
							)
						).join('|'),
						'i'
					),
					token = localStorage.getItem('__authenticationToken__'),
					tokenType =
						localStorage.getItem('__authenticationTokenType__') || 'Bearer';

				if (
					token &&
					re.test(config.url) &&
					token != 'undefined' &&
					tokenType != 'undefined'
				)
					config.headers.Authorization = `${tokenType} ${token}`;

				return config;
			},
			response(response) {
				if (response.config.url.indexOf('.html') != -1) return response;

				let config = response.config,
					currentAPIKey = Object.keys(API).find(
						key =>
							key !== 'default' &&
							helper.http(API[key], config.method, config.params).url ===
								config.url
					);

				if (API.hasOwnProperty(currentAPIKey)) {
					let currentAPI = API[currentAPIKey];

					if (
						typeof currentAPI === 'object' &&
						typeof currentAPI.hooks === 'object' &&
						typeof currentAPI.hooks.response === 'function'
					) {
						currentAPI.hooks.response(response);
					}
				}

				return responseHook(response);
			},
			responseError(rejection) {
				return responseHook(rejection);
			}
		};
	}
]);

/* Verfica se a requisição (ou o objeto `config`) deseja sobrescrever a notificação da resposta da requisição. */

function hasMessagesOverrides(request) {
	const { success, error } = request.messageOverride || {};

	return {
		success: typeof success === 'function',
		error: typeof error === 'function'
	};
}
